var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8235 5.12484L5.8708 4.2286C6.15716 3.98306 6.35843 3.66319 6.44878 3.31004C6.53913 2.9569 6.51444 2.58659 6.37787 2.24665L5.93126 1.13272C5.7644 0.716852 5.43407 0.376051 5.00758 0.179745C4.58108 -0.016562 4.0905 -0.0536045 3.63579 0.0761637C1.96245 0.554345 0.676249 2.0071 1.07215 3.7322C1.33252 4.86708 1.83081 6.29161 2.77474 7.80721C3.72062 9.32646 4.80107 10.4486 5.72745 11.2374C7.1258 12.426 9.12482 12.1291 10.411 11.0087C10.7558 10.7085 10.965 10.2967 10.996 9.85736C11.027 9.41801 10.8774 8.98417 10.5778 8.64426L9.75866 7.71522C9.51162 7.43428 9.18022 7.22881 8.80711 7.12525C8.43401 7.02169 8.03626 7.02478 7.66505 7.13412L6.31156 7.53214C5.96202 7.19521 5.65571 6.82138 5.39883 6.41821C5.15089 6.01049 4.95765 5.57579 4.8235 5.12393V5.12484Z",
    fill: "#225FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.4e0205ff5b6bbd4fd69529ff0c1d9e16.svg";
export { ForwardRef as ReactComponent };